// Admin authorization (frontend gate ONLY — server is the source of truth).
// Keep this list in sync with backend ADMIN_EMAILS in server.py.
export const ADMIN_EMAILS = [
  'rggilmore@gmail.com',
  'ronettagilmore83@gmail.com',
];

export function getCachedUser() {
  try {
    return JSON.parse(localStorage.getItem('zenscroll_user') || 'null');
  } catch {
    return null;
  }
}

export function isAdmin() {
  const u = getCachedUser();
  const email = (u?.email || '').toLowerCase();
  return ADMIN_EMAILS.includes(email);
}
